export const firebaseConfig = () => ({
  apiKey: FIREBASE_API_KEY,
  authDomain: APP_DOMAIN || FIREBASE_AUTH_DOMAIN,
  projectId: FIREBASE_PROJECT_ID,
  storageBucket: FIREBASE_STORAGE_BUCKET,
  messagingSenderId: FIREBASE_MESSAGING_SENDER_ID,
  appId: FIREBASE_APP_ID,
});
